import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSwarmComponent } from './simple-icons-swarm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSwarmComponent ],
    exports:      [ SimpleIconsSwarmComponent ],
    bootstrap:    []
})
export class SimpleIconsSwarmModule {}
